"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    InteractionTag: function() {
        return _index.InteractionTag;
    },
    interactionTagClassNames: function() {
        return _index.interactionTagClassNames;
    },
    renderInteractionTag_unstable: function() {
        return _index.renderInteractionTag_unstable;
    },
    useInteractionTagContextValues_unstable: function() {
        return _index.useInteractionTagContextValues_unstable;
    },
    useInteractionTagStyles_unstable: function() {
        return _index.useInteractionTagStyles_unstable;
    },
    useInteractionTag_unstable: function() {
        return _index.useInteractionTag_unstable;
    }
});
const _index = require("./components/InteractionTag/index");
